import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useConstant } from "@/shared/hooks/use-constant";
import { useUserState } from "@/shared/stores/app-state";
import { UIFlatIcon } from "@/shared/ui/ui-flat-icon";

import { wsConnection } from "./model/ws-connection";
import { WSStore } from "./model/ws-store";

export const StatusConnection = observer(() => {
	const store = useConstant(() => new WSStore());
	const {
		getStatusInfo: { title, color },
		getIntervalHandler,
		getFirstRequest,
		setFirstRequest,
		getDelayTitle,
		setDelay,
	} = store;
	const { logOut } = useUserState();

	useEffect(() => {
		if (getFirstRequest === 0) {
			setFirstRequest(1);
		} else {
			wsConnection(getIntervalHandler, setDelay, logOut);
		}
	}, [getFirstRequest, getIntervalHandler]);

	return (
		<div data-testid="statusConnection">
			<Sentry.ErrorBoundary>
				<Tooltip title={getDelayTitle()} placement="topLeft">
					<div className="text-sm flex items-center gap-4">
						<UIFlatIcon name="fi-rr-signal-alt-2" size={14} style={{ color }} />

						<span data-testid="title">{title}</span>
					</div>
				</Tooltip>
			</Sentry.ErrorBoundary>
		</div>
	);
});
